<div class="row no-gutters signin-page">
  <div class="col-md-7 col-lg-6 col-sm-12 form-section">
    <h1 class="page-title">Welcome To ClariChat</h1>
    <p class="page-subtitle">
The Most Models on one platform. 
    </p>

    <div class="compliance-links">
      <button type="button" class="link-button" (click)="openRequirementsDialog()">Data · Privacy</button>
    </div>

    <form class="signin-form" [formGroup]="signinForm" (ngSubmit)="onSignin()">
      <div *ngIf="loggedOutTitle || loggedOutSubtitle" class="alert alert-success mt-3">
        <div *ngIf="loggedOutTitle">{{ loggedOutTitle }}</div>
        <div *ngIf="loggedOutSubtitle">{{ loggedOutSubtitle }}</div>
      </div>

      <div *ngIf="authError" class="alert alert-danger mt-3">{{ authError }}</div>
      <div *ngIf="emailLinkInfo" class="alert alert-info mt-3">{{ emailLinkInfo }}</div>
      <div *ngIf="socialAuthError" class="alert alert-danger mt-3">{{ socialAuthError }}</div>

      <div class="form-group">
        <input type="email" class="form-control" id="email" placeholder="Email" formControlName="email">
      </div>
      <br>
      <div class="form-group">
        <input type="password" class="form-control" id="password" placeholder="Password" formControlName="password">
      </div>
      <div class="form-call-to-actions">
        <a class="forgot-password-link" routerLink="/auth/signup">Sign Up</a>
        <button class="sign-in-btn" type="submit">Sign In</button>
      </div>
    </form>

    <div class="register-divider">
      <hr class="line"><span>Sign in using</span><hr class="line">
    </div>
    <div class="social-logins row no-gutters">
      <button type="button" class="google-signin" (click)="onGoogleSignin()">
        Google
      </button>
      <button type="button" class="signup-social-btn" [routerLink]="['/auth/forgot-password']">
        Forgot Password?
      </button>
    </div>

  </div>

  <div class="col-md-5 col-lg-6 d-none d-md-block image-section">
    &nbsp; 
    &nbsp; 
      &nbsp; 
    &nbsp; 
       &nbsp; 
    &nbsp; 
    <img [src]="'/assets/img/brain.png'" class="signin-image add-overlay log-inimg"/>
  </div>
</div>

<app-privacy-policy-dialog
  [isOpen]="isPrivacyDialogOpen"
  (closed)="closePrivacyDialog()">
</app-privacy-policy-dialog>

<app-data-requirements-dialog
  [isOpen]="isRequirementsDialogOpen"
  (closed)="closeRequirementsDialog()">
</app-data-requirements-dialog>
